<template>
    <div ref="splideRef" class="splide overflow-hidden">
        <div class="splide__track carousel lg:py-14">
            <div class="splide__list">
                <div v-for="(slide, i) in source.pages" :key="i" class="splide__slide flex w-full items-center justify-center">
                    <div class="flex h-full max-w-[90%] flex-col justify-center py-[6%] text-center lg:max-w-[60%]">
                        <div class="pt-[30px] text-sm max-lg:px-10 lg:text-2xl" v-html="slide.text"></div>
                        <p class="black-link text-[14px] font-black underline underline-offset-8 lg:text-[24px]">{{ slide.linkText }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Splide from "@splidejs/splide";
const splideRef = ref();
const props = defineProps({
    source: Object,
});
function initSwiper() {
    new Splide(splideRef.value, {
        type: "loop",
        pagination: true,
        speed: 600,

        classes: {
            arrows: "splide__arrows butinfo-splide-arrows",
            arrow: "splide__arrow butinfo-splide-arrow",
            prev: "splide__arrow--prev butinfo-splide-prev",
            next: "splide__arrow--next butinfo-splide-next",

            pagination: "splide__pagination butinfo-splide-pagination",
            page: "splide__pagination__page butinfo-splide-page",
        },
    }).mount();
}

onMounted(async () => {
    await nextTick();

    setTimeout(() => {
        initSwiper();
    }, 0);
});
</script>
<style scoped lang="scss">
.carousel {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: url(../../../assets/images/GroupBGI.png) no-repeat center;
    background-size: cover;
}
/* .mbtu {
    position: absolute;
    top: 0;
    left: 300px;
    width: 180px;
    height: 205px;
    background-image: url(../../../assets/images/mengbantu.png);
} */
.slider {
    display: flex;
    /* width: 400%; */
    /* height: 500px; */
    /* transition: transform 0.5s ease; */
}

.slide {
    width: 25%;
    /* flex: 1; */
    position: relative;
}

.bgimg {
    width: 100%;
    height: 500px;
}
.text-content {
    margin-left: 390px;
    padding-top: 100px;
}

.black-link {
    color: #000;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 50px;
}
// :deep(.splide__pagination) {
//     @apply mt-10;
// }
:deep(.splide__pagination.butinfo-splide-pagination .is-active) {
    background: rgb(255, 49, 228);
    width: 12px;
    height: 6px;
    border-radius: 3px;
    margin-right: 0.5rem;
    margin-bottom: 0.25rem;
}
:deep(.splide__arrow.butinfo-splide-arrow svg) {
    display: none;
}
:deep(.splide__arrow.butinfo-splide-arrow.splide__arrow--next) {
    position: absolute;
    right: 200px;
    top: 50%;
    transform: translateY(-50%);
    background: url("../../../assets/images/arrow-right.png") no-repeat !important;
    display: block !important;
}
:deep(.splide__arrow.butinfo-splide-arrow.splide__arrow--prev) {
    position: absolute;
    left: 200px;
    top: 50%;
    transform: translateY(-50%);
    background: url("../../../assets/images/arrow-left.png") no-repeat !important;
    display: block !important;
}
:deep(.splide__pagination.butinfo-splide-pagination.splide__pagination--ltr) {
    @apply absolute bottom-0 lg:bottom-[40px];
}
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.5s ease-in-out;
}

.fade-slide-enter,
.fade-slide-leave-to {
    opacity: 0;
}
.popup_side {
    position: fixed;
    border-radius: 0 8px 8px 0;
    top: calc(50% - 60px);
    background-color: #f25929;
    left: 0%;
    width: 32px;
    height: 200px;
    background: #f19cd9;
    cursor: pointer;
    z-index: 9999;
    display: inline-block;
    white-space: nowrap;

    .text {
        display: inline-block;
        color: #fff;
        writing-mode: vertical-rl;
        width: 100%;
        height: 100%;
        line-height: 32px;
        text-align: center;
        transform: rotate(180deg);
    }
}
@media screen and (max-width: 768px) {
    :deep(.splide__arrow.butinfo-splide-arrow.splide__arrow--next) {
        right: 20px;
        opacity: 0.4;
    }
    :deep(.splide__arrow.butinfo-splide-arrow.splide__arrow--prev) {
        left: 20px;
        opacity: 0.4;
    }
}
</style>
